var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackupFunds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67498",
    "data-name": "Group 67498",
    transform: "translate(-658 -756)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22413",
    "data-name": "Rectangle 22413",
    width: 72,
    height: 72,
    transform: "translate(658 756)",
    fill: "#fff5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-life-ring",
    transform: "translate(673.998 771.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67407",
    "data-name": "Group 67407",
    transform: "translate(0.001 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67406",
    "data-name": "Group 67406",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80468",
    "data-name": "Path 80468",
    d: "M35.26,32.9a19.923,19.923,0,0,0,0-25.8l1.433-1.433A1.667,1.667,0,0,0,34.335,3.31L32.9,4.743a19.923,19.923,0,0,0-25.8,0L5.665,3.31A1.667,1.667,0,1,0,3.309,5.668L4.743,7.1a19.923,19.923,0,0,0,0,25.8L3.31,34.338a1.667,1.667,0,1,0,2.359,2.355L7.1,35.26a19.923,19.923,0,0,0,25.8,0l1.433,1.433a1.667,1.667,0,1,0,2.355-2.359ZM36.668,20a16.582,16.582,0,0,1-3.77,10.54L26.946,24.59a8.277,8.277,0,0,0,0-9.177L32.9,9.461A16.582,16.582,0,0,1,36.668,20ZM15,20a5,5,0,1,1,5,5A5,5,0,0,1,15,20ZM20,3.335A16.582,16.582,0,0,1,30.541,7.1L24.59,13.056a8.277,8.277,0,0,0-9.177,0L9.461,7.1A16.582,16.582,0,0,1,20,3.335ZM3.335,20A16.582,16.582,0,0,1,7.1,9.461l5.952,5.952a8.277,8.277,0,0,0,0,9.177L7.1,30.541A16.582,16.582,0,0,1,3.335,20ZM20,36.668A16.582,16.582,0,0,1,9.461,32.9l5.952-5.952a8.277,8.277,0,0,0,9.177,0L30.541,32.9A16.582,16.582,0,0,1,20,36.668Z",
    transform: "translate(-0.001 -0.001)",
    fill: "#ff8383"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackupFunds);
export default __webpack_public_path__ + "static/media/backup-funds.634ff69df5f26128200f22634e6b9a8b.svg";
export { ForwardRef as ReactComponent };